import { render, staticRenderFns } from "./notificationsmanagement.vue?vue&type=template&id=102d4f62&"
import script from "./notificationsmanagement.vue?vue&type=script&lang=js&"
export * from "./notificationsmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports